<div>
  <div *ngFor="let msg of messages">{{ msg }}</div>
  <input [(ngModel)]="message" placeholder="Type your message here"/>
  <button (click)="sendMessage()">Send</button>
</div>
